var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { Annonce } from 'annonce/classes/Annonce.class';
import { AnnonceCategorie } from 'annonce/classes/AnnonceCategorie.class';
import axiosInstance from '../../store/AxiosSingleton';
export class AnnonceService {
    /**
     * Charge les catégories
     * @return liste des catégories
     */
    static loadCategorie() {
        return __awaiter(this, void 0, void 0, function* () {
            const { data: { content }, } = yield axiosInstance.get('/index.php', {
                params: {
                    rub: AnnonceService.rubModule,
                    action: 'LOAD_CATEGORIE',
                },
            });
            return content.map((maCategorie) => new AnnonceCategorie(maCategorie));
        });
    }
    /**
     * Charge les annonces d'une catégorie
     * @param idAnnonceCategorie Identifiant de la catégorie
     * @return Liste des annonces de la catégorie
     */
    static loadAnnonce(idAnnonceCategorie) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data: { content }, } = yield axiosInstance.get('/index.php', {
                params: {
                    rub: AnnonceService.rubModule,
                    action: 'LOAD_ANNONCE',
                    idAnnonceCategorie,
                },
            });
            return content.map((monAnnonce) => new Annonce(monAnnonce));
        });
    }
    /**
     * Charge le nombre d'annonces non-modérées
     * @return Nombre d'annonces non-modérées
     */
    static loadUnmoderatedAnnonceAmount() {
        return __awaiter(this, void 0, void 0, function* () {
            const { data: { content }, } = yield axiosInstance.get('/index.php', {
                params: {
                    rub: AnnonceService.rubModule,
                    action: 'LOAD_UNMODERATED_ANNONCE_AMOUNT',
                },
            });
            return content;
        });
    }
}
AnnonceService.rubModule = 'annonce';
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoic2VydmljZS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbInNlcnZpY2UudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7O0FBQUEsT0FBTyxFQUFFLE9BQU8sRUFBRSxNQUFNLCtCQUErQixDQUFDO0FBQ3hELE9BQU8sRUFBRSxnQkFBZ0IsRUFBRSxNQUFNLHdDQUF3QyxDQUFDO0FBQzFFLE9BQU8sYUFBYSxNQUFNLDRCQUE0QixDQUFDO0FBRXZELE1BQU0sT0FBTyxjQUFjO0lBRzFCOzs7T0FHRztJQUNJLE1BQU0sQ0FBTyxhQUFhOztZQUNoQyxNQUFNLEVBQ0wsSUFBSSxFQUFFLEVBQUUsT0FBTyxFQUFFLEdBQ2pCLEdBQUcsTUFBTSxhQUFhLENBQUMsR0FBRyxDQUFDLFlBQVksRUFBRTtnQkFDekMsTUFBTSxFQUFFO29CQUNQLEdBQUcsRUFBRSxjQUFjLENBQUMsU0FBUztvQkFDN0IsTUFBTSxFQUFFLGdCQUFnQjtpQkFDeEI7YUFDRCxDQUFDLENBQUM7WUFFSCxPQUFPLE9BQU8sQ0FBQyxHQUFHLENBQUMsQ0FBQyxXQUFzQyxFQUFFLEVBQUUsQ0FBQyxJQUFJLGdCQUFnQixDQUFDLFdBQVcsQ0FBQyxDQUFDLENBQUM7UUFDbkcsQ0FBQztLQUFBO0lBRUQ7Ozs7T0FJRztJQUNJLE1BQU0sQ0FBTyxXQUFXLENBQUMsa0JBQTBCOztZQUN6RCxNQUFNLEVBQ0wsSUFBSSxFQUFFLEVBQUUsT0FBTyxFQUFFLEdBQ2pCLEdBQUcsTUFBTSxhQUFhLENBQUMsR0FBRyxDQUFDLFlBQVksRUFBRTtnQkFDekMsTUFBTSxFQUFFO29CQUNQLEdBQUcsRUFBRSxjQUFjLENBQUMsU0FBUztvQkFDN0IsTUFBTSxFQUFFLGNBQWM7b0JBQ3RCLGtCQUFrQjtpQkFDbEI7YUFDRCxDQUFDLENBQUM7WUFFSCxPQUFPLE9BQU8sQ0FBQyxHQUFHLENBQUMsQ0FBQyxVQUE0QixFQUFFLEVBQUUsQ0FBQyxJQUFJLE9BQU8sQ0FBQyxVQUFVLENBQUMsQ0FBQyxDQUFDO1FBQy9FLENBQUM7S0FBQTtJQUVEOzs7T0FHRztJQUNJLE1BQU0sQ0FBTyw0QkFBNEI7O1lBQy9DLE1BQU0sRUFDTCxJQUFJLEVBQUUsRUFBRSxPQUFPLEVBQUUsR0FDakIsR0FBRyxNQUFNLGFBQWEsQ0FBQyxHQUFHLENBQUMsWUFBWSxFQUFFO2dCQUN6QyxNQUFNLEVBQUU7b0JBQ1AsR0FBRyxFQUFFLGNBQWMsQ0FBQyxTQUFTO29CQUM3QixNQUFNLEVBQUUsaUNBQWlDO2lCQUN6QzthQUNELENBQUMsQ0FBQztZQUVILE9BQU8sT0FBTyxDQUFDO1FBQ2hCLENBQUM7S0FBQTs7QUFyRHVCLHdCQUFTLEdBQUcsU0FBUyxDQUFDIn0=